import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from 'components/Grid';
import { Heading } from 'components/Heading';
import { Text } from 'components/Text';
import { cx } from 'utility';
import * as styles from './SectionHeader.module.scss';

const propTypes = {
    className: PropTypes.string,
    description: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
};

const defaultProps = {
    className: '',
    description: '',
    title: '',
    type: '',
};

function getClasses({ className, type }) {
    const classes = cx(
        className,
        styles['sectionHeader'],
        styles[`${type}`],
    );

    return classes || undefined;
}

function SectionHeader({
    className,
    description,
    title,
    type,
}) {
    const classes = getClasses({ className, type });
    const headingEmphasis = type === 'simple' ? 'low' : 'high';
    const headingSize = type === 'simple' ? 3 : 8;

    return (
        <div className={classes} id={title.replace(/\s+/g, '-').toLowerCase()}>
            <Grid>
                {title && (
                    <Heading
                        className={styles['title']}
                        emphasis={headingEmphasis}
                        size={headingSize}
                    >
                        {title}
                    </Heading>
                )}
                {description && (
                    <Text
                        as="p"
                        className={styles['description']}
                        size={3}
                    >
                        {description}
                    </Text>
                )}
            </Grid>
        </div>
    );
}

SectionHeader.propTypes = propTypes;
SectionHeader.defaultProps = defaultProps;

export { SectionHeader };
